// @ts-nocheck
//
// Canonical role names (lowercase camelCase) — aligns with the backend post-unify.
// The backend canonicalizes 'Admin'/'admin' → 'admin' and 'FreelanceEC'/'Freelancer EC'
// → 'freelanceEc' in the migration. Here we use the same convention.

const userRoles = {
  client: "client",
  coordinator: "coordinator",
  subCoordinator: "subCoordinator",
  contractor: "contractor",
  admin: "admin",
  superAdmin: "superAdmin",
  freelanceEc: "freelanceEc",
  marketing: "marketing",
  // `contact` removed as a login-able role. It exists in the
  // `contactinformations` collection (emergency event contact), not in users.
};

const USER_ROLES = {
  CLIENT: "client",
  COORDINATOR: "coordinator",
  SUB_COORDINATOR: "subCoordinator",
  CONTRACTOR: "contractor",
  ADMIN: "admin",
  SUPERADMIN: "superAdmin",
  // Canonical: freelanceEc.
  FREELANCE_EC: "freelanceEc",
  MARKETING: "marketing",
};

/**
 * List of roles that have their own Layout/Sidebar in the SPA. So the role
 * switcher knows whether the UI supports each activeRole.
 */
const ROLES_WITH_LAYOUT = [
  "superAdmin",
  "admin",
  "client",
  "coordinator",
  "contractor",
  "freelanceEc",
  "marketing",
];

/** Friendly display names for the UI (chips, dropdowns). */
const ROLE_DISPLAY_NAMES = {
  superAdmin: "Super Admin",
  admin: "Admin",
  client: "Client",
  coordinator: "Coordinator",
  subCoordinator: "Sub Coordinator",
  contractor: "Contractor",
  freelanceEc: "Freelancer EC",
  marketing: "Marketing",
};

export { userRoles, USER_ROLES, ROLES_WITH_LAYOUT, ROLE_DISPLAY_NAMES };